import { render, staticRenderFns } from "./StockSlipBase.vue?vue&type=template&id=04165b2a&scoped=true"
import script from "./StockSlipBase.vue?vue&type=script&lang=js"
export * from "./StockSlipBase.vue?vue&type=script&lang=js"
import style1 from "./StockSlipBase.vue?vue&type=style&index=1&id=04165b2a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04165b2a",
  null
  
)

export default component.exports